import { getCookie } from '@which/shared'

/**
 * Shared utilities for Header component props.
 * Used by both SSR renderer and client-side entry.
 */

export const getIsHomepage = (path: string) => path === '/'

export const getUserLoggedIn = (cookieString: string) =>
  Boolean(getCookie(cookieString, 'blaize_session'))

const ACCOUNTS_URLS = ['/registration', '/login', '/forgot-password', '/reset-password']

export const isAccountsUrl = (url: string) =>
  Boolean(url) && ACCOUNTS_URLS.some((matchingUrl) => url.includes(matchingUrl))

export const getSimplifiedNav = (url: string) => isAccountsUrl(url)
